import { CollectionImage } from '~/components/collections/CollectionImage';
import { CurrencyIcon } from '~/components/collections/CurrencyIcon';
import {
	Button,
	ButtonBorderRadius,
	ButtonColors,
	ButtonHeight,
} from '~/components/ui/Button';
import { Divider } from '~/components/ui/Divider';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import { Currency } from '~/shared';
import {
	setMyBusinessShopItemPageVisible,
	useLayoutDispatch,
} from '../../redux';
import {
	StyledContainer,
	StyledImageContainer,
	StyledInfoRow,
	StyledItemShadow,
	StyledRightInfoContainer,
} from './AppMyBusinessShopItem.styled';

const AppMyBusinessShopItem = () => {
	const dispatch = useLayoutDispatch();
	const rubleIcon = useWalletIcon(Currency.Ruble, true);

	return (
		<StyledContainer>
			<StyledItemShadow />
			<Text style={{ fontSize: 16, fontWeight: 500, color: '#FFFFFF' }}>
				Топливо АИ - 92
			</Text>
			<StyledImageContainer>
				<CollectionImage collection="items" id="apple" size={100} />
			</StyledImageContainer>
			<StyledInfoRow>
				<Text style={{ fontSize: 14, color: '#FFFFFF', opacity: 0.25 }}>
					В наличии
				</Text>
				<StyledRightInfoContainer>
					<Text style={{ fontSize: 14, color: '#FFFFFF', fontWeight: 700 }}>
						25 000
					</Text>
					<Text style={{ fontSize: 14, color: '#FFFFFF', opacity: 0.25 }}>
						л.
					</Text>
				</StyledRightInfoContainer>
			</StyledInfoRow>
			<StyledInfoRow style={{ marginTop: 10 }}>
				<Text style={{ fontSize: 14, color: '#FFFFFF', opacity: 0.25 }}>
					Стоимость
				</Text>
				<StyledRightInfoContainer>
					<Text style={{ fontSize: 14, color: '#FFFFFF', fontWeight: 700 }}>
						25 000
					</Text>
					<CurrencyIcon icon={rubleIcon} size="sm" color="#3491E9" asMask />
					<Text style={{ fontSize: 14, color: '#FFFFFF', opacity: 0.25 }}>
						л.
					</Text>
				</StyledRightInfoContainer>
			</StyledInfoRow>
			<Divider
				$direction="H"
				style={{ marginTop: 20, marginBottom: 20, opacity: 0.1 }}
			/>
			<Button
				color={ButtonColors.LightBlue}
				height={ButtonHeight.Height40}
				borderRadius={ButtonBorderRadius.Radius5}
				onClick={() => dispatch(setMyBusinessShopItemPageVisible(true))}
			>
				<Text>Открыть товар</Text>
			</Button>
		</StyledContainer>
	);
};

export { AppMyBusinessShopItem };
